import { timer } from 'rxjs';
import { Component } from '@angular/core';
import { MessagesService } from 'src/app/services/messages.service';

@Component({
  selector: 'app-menssages',
  templateUrl: './menssages.component.html',
  styleUrls: ['./menssages.component.css']
})
export class MenssagesComponent {

  message: { type: 'success' | 'error' | 'vacio'; message: string } = { type: 'vacio', message: '' };

  constructor(private messagesService: MessagesService) {
    this.messagesService.message$.subscribe((message) => {
      this.message = message;
      timer(3500).subscribe(() => {
        this.clearMessage();
      });
    });
  }

  clearMessage() {
    this.message = { type: 'vacio', message: '' };
  }

}
